var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register-content col-12 py-1 py-md-0 pb-md-1"},[_c('SButtonMaterial',{staticClass:"register-button",attrs:{"buttonType":"button","textColor":"white","size":"lg","color":"primary","materialClass":"dense","text":"REGISTER FOR A FREE ACCOUNT","to":"/signup","data-cy":"lpRegisterBtn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }